import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Mail, MapPin, Linkedin, Twitter } from 'lucide-react';
import '../styles/Contact.css';

const Contact: React.FC = () => {

  return (
    <>
      <Helmet>
        <title>Contact Pedro Sugasti - Get In Touch</title>
        <meta name="description" content="Get in touch with Pedro Sugasti for broadcast graphics, data visualization, and creative development projects. Ready to collaborate on your next project." />
        
        {/* Open Graph tags */}
        <meta property="og:title" content="Contact Pedro Sugasti - Get In Touch" />
        <meta property="og:description" content="Ready to collaborate on your next broadcast or creative development project? Get in touch with Pedro Sugasti today." />
        <meta property="og:image" content="https://pedrosugasti.com/profile-photo.jpg" />
        <meta property="og:url" content="https://pedrosugasti.com/contact" />
        <meta property="og:type" content="website" />
        
        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Contact Pedro Sugasti" />
        <meta name="twitter:description" content="Get in touch for broadcast graphics and creative development projects." />
        <meta name="twitter:image" content="https://pedrosugasti.com/profile-photo.jpg" />
        
        <link rel="canonical" href="https://pedrosugasti.com/contact" />
      </Helmet>
      
      <div className="contact">
        <section className="contact-hero-split">
          <div className="contact-hero-left">
            <div className="contact-image-container">
              <div className="contact-icon-display">
                <Mail size={120} className="contact-main-icon" />
              </div>
            </div>
          </div>
          <div className="contact-hero-right">
            <motion.div 
              className="contact-hero-content"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <motion.h1 
                className="contact-hero-title"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
              >
                Get In <span className="highlight">Touch</span>
              </motion.h1>
              <motion.p 
                className="contact-hero-description"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
              >
                Ready to collaborate on your next project? Let's discuss how we can bring your broadcast graphics and interactive media ideas to life. Whether you have a specific project in mind or just want to explore possibilities, I'd love to hear from you.
              </motion.p>
              
              <motion.div 
                className="contact-info-quick"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6 }}
              >
                <div className="contact-quick-item">
                  <MapPin size={20} />
                  <span>Available for projects worldwide</span>
                </div>
              </motion.div>
              
              <motion.div 
                className="contact-social-links"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.8 }}
              >
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <Linkedin size={20} />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <Twitter size={20} />
                </a>
              </motion.div>
              
              <motion.div 
                className="contact-cta"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1 }}
              >
                <p className="contact-coming-soon">
                  Contact form coming soon. In the meantime, please reach out through social media.
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Contact;